module.exports = __webpack_public_path__ + "0f12d30cd1bc75d3d38768f1aa7d4d90.svg";